import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = { class: "col" }
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "mb-3" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "mb-3" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col" }
const _hoisted_48 = { class: "mb-3" }
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "mb-3" }
const _hoisted_51 = { class: "col" }
const _hoisted_52 = { class: "mb-3" }
const _hoisted_53 = { class: "form-check form-switch" }
const _hoisted_54 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("h3", null, "Add new turbine model")
      ], -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errorMsg), 1))
              : _createCommentVNode("", true),
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "modal-section-title" }, [
              _createElementVNode("h5", null, "New turbine model config"),
              _createElementVNode("p", null, "Information that is required for a turbine model")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label" }, "Model name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label" }, "Power in KW", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.power) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.power]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label" }, "Turbine designer", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.designer_id) = $event)),
                    class: "form-select"
                  }, [
                    _cache[23] || (_cache[23] = _createElementVNode("option", { value: null }, "Select designer", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.design_companies, (company) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: company.company_id,
                        value: company.company_id
                      }, _toDisplayString(company.name), 9, _hoisted_14))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.designer_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label" }, "Manufacturer", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.manufacturer) = $event)),
                    class: "form-select"
                  }, [
                    _cache[25] || (_cache[25] = _createElementVNode("option", { value: null }, "Select manufacturer", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manufacturing_companies, (company) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: company.company_id,
                        value: company.company_id
                      }, _toDisplayString(company.name), 9, _hoisted_17))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.manufacturer]
                  ])
                ])
              ])
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("hr", null, null, -1)),
            _cache[44] || (_cache[44] = _createElementVNode("p", null, "Additional information for turbine model configuration", -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label" }, "Gearbox type", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.gearbox) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.gearbox]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label" }, "Max hub height", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.max_hub_height) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.max_hub_height]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label" }, "Min hub height", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.min_hub_height) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.min_hub_height]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "form-label" }, "Max rotor speed", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.max_rotor_speed) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.max_rotor_speed]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label" }, "Min rotor speed", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.min_rotor_speed) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.min_rotor_speed]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { class: "form-label" }, "Necelle weight", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.nacelle_weight) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.nacelle_weight]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label" }, "Number of blades", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.num_blades) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.num_blades]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "form-label" }, "Rated wind speed", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.rated_wind_speed) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.rated_wind_speed]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label" }, "Rotor diameter (m)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.rotor_diameter) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.rotor_diameter]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label" }, "Rotor weight (kg)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.rotor_weight) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.rotor_weight]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label" }, "Swept area (m^2)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.swept_area) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.swept_area]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label" }, "total weight (kg)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.total_weight) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.total_weight]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label" }, "Tower weight (kg)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.tower_weight) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.tower_weight]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label" }, "Wind class", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.wind_class) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.wind_class]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("input", {
                      id: "offshore-switch",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.offshore) = $event)),
                      class: "form-check-input",
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.offshore]
                    ]),
                    _cache[41] || (_cache[41] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "offshore-switch"
                    }, " Offshore rated turbine? ", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                type: "button",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, "Save")
            ])
          ]))
    ])
  ]))
}